import { useEffect, useState } from "react";
import { SystemViewUserItemType } from "@/schemas/index";
import { useLoader } from "@/app/hook/use-loader";
import { useForm } from "@/base/utils/index";
import { useFormWatch } from "@/base/utils/index";
import { useLocalization } from "@/app/hook/use-localization";
import { useTable } from "../hooks/use-table";

export function usePageSystemViewHook() {
  const localization = useLocalization();
  const { setLoader } = useLoader();
  const [form] = useForm();
  const query = useFormWatch("query", form);
  const [selectedUserId, setSelectedUserId] =
    useState<SystemViewUserItemType["Id"]>();

  const controllerDataTable = useTable();

  useEffect(() => {
    if (controllerDataTable.initial) {
      controllerDataTable.setFilter({ query });
    }
  }, [query]);

  useEffect(() => {
    setLoader(false);
  }, []);

  return {
    form,
    localization,
    controllerDataTable,
    selectedUserId,
    setSelectedUserId,
  };
}
